// src/context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from "react";
import { login as apiLogin, logout as apiLogout, getProfile } from "../api/authApi";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const handleLogin = async (username, password) => {
    const { user } = await apiLogin(username, password);
    setUser(user);
    return user;
  };

  const handleLogout = () => {
    apiLogout();
    setUser(null);
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const userProfile = await getProfile();
        localStorage.setItem("user", JSON.stringify(userProfile));
        setUser(userProfile);
      } catch {
        if (!localStorage.getItem("accessToken")) setUser(null);
      } finally { setLoading(false); }
    };
    checkUser();
    const refreshAccess = async () => {
      try {
        const profile = await getProfile();
        localStorage.setItem("user", JSON.stringify(profile));
        setUser(profile);
      } catch { /* keep the session on transient failures */ }
    };
    window.addEventListener("smartharvest:access-changed", refreshAccess);
    return () => window.removeEventListener("smartharvest:access-changed", refreshAccess);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, handleLogin, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
